import type { TextareaHTMLAttributes } from "react";

import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";

interface CustomTextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  height?: string;
}

export const CustomTextarea = ({
  height = "h-20",
  className,
  ...props
}: CustomTextareaProps) => {
  return (
    <Textarea
      className={cn(
        "resize-none shadow-none",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        height,
        className
      )}
      {...props}
    />
  );
};
